import React, { useState } from 'react';
import api from '../services/api';
import { useAuth } from '../contexts/AuthContext';
import Button from '../common/Button';
import Input from '../common/Input';
import Toast from '../common/Toast';

const WalletTopup = () => {
  const [amount, setAmount] = useState('');
  const [method, setMethod] = useState('mobile_money');
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState(null);
  const { user, setUser } = useAuth();

const handleTopup = async (e) => {
  e.preventDefault();
  if (!amount || isNaN(amount) || Number(amount) <= 0) {
    setToast({ message: 'Please enter a valid amount', type: 'error' });
    return;
  }

  setLoading(true);
  console.log('🚀 Sending topup request...');
  try {
    const { data } = await api.post('/passenger/topup', {
      amount: parseFloat(amount),
      method,
    });
    console.log('✅ Topup response:', data);
    setUser({ ...user, wallet_balance: data.new_balance });
    setToast({ message: `Topup successful! New balance: $${data.new_balance}`, type: 'success' });
    setAmount('');
  } catch (err) {
    console.error('❌ Topup error:', err);
    if (err.code === 'ECONNABORTED') {
      // Timeout
      setToast({ message: 'Request timed out. The server is busy, please try again.', type: 'error' });
    } else {
      const errorMsg =
        err.response?.data?.error ||
        err.response?.data?.message ||
        'Topup failed. Please try again.';
      setToast({ message: errorMsg, type: 'error' });
    }
  } finally {
    setLoading(false);
  }
};

  return (
    <div className="glass-card fade-in">
      <h2>Wallet Balance</h2>
      <div className="balance-display">
        ${Number(user?.wallet_balance || 0).toFixed(2)}
      </div>
      <form onSubmit={handleTopup}>
        <Input
          label="Amount"
          type="number"
          min="0.01"
          step="0.01"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          required
        />
        <div className="input-group">
          <label>Payment Method</label>
          <select value={method} onChange={(e) => setMethod(e.target.value)}>
            <option value="mobile_money">Mobile Money</option>
            <option value="visa">Visa</option>
            <option value="mastercard">Mastercard</option>
          </select>
        </div>
        <Button type="submit" disabled={loading}>
          {loading ? 'Processing...' : 'Top Up Now'}
        </Button>
      </form>
      {toast && <Toast message={toast.message} type={toast.type} onClose={() => setToast(null)} />}
      <style>{`
        .balance-display {
          font-size: 2.5rem;
          font-weight: 700;
          color: var(--primary);
          margin: 1rem 0 2rem;
        }
      `}</style>
    </div>
  );
};

export default WalletTopup;